import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { Button } from '@repo/ui';
import { useIsMobile } from '@repo/mui-config/hooks';

import { LoanProcessStatusIconWrapper } from '@/components/loan-process/loan-process-status-icon-wrapper';
import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import { useLoanProcessStore } from '@/components/loan-process/store/loan-process.store';
import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';
import { useMainHubStoreActions } from '@/store/main-hub.store';
import { VIEW_TYPE } from '@/store/view.type';

export function ApplicationNegative() {
  const isMobile = useIsMobile();
  useLoanProcessSetCurrentModalState('ApplicationNegative');
  const { t } = useTranslation();
  const {
    actions: { clearLoanProcessStore },
    state: { loanRejectionDescription },
  } = useLoanProcessStore();
  const { setCurrentView } = useMainHubStoreActions();

  const closeModalAndGoToDashboard = () => {
    clearLoanProcessStore();
    setCurrentView(VIEW_TYPE.DASHBOARD);
  };

  return (
    <Box data-testid="application-negative" sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <LoanProcessModalHeader containerSx={{ mb: isMobile ? 4 : 8 }} />
      <Stack
        alignContent="center"
        alignItems="center"
        gap={7}
        sx={{ marginBottom: '64px', paddingX: '20px' }}
      >
        <Typography component="p" textAlign="center" variant="h5">
          {t('loanProcess.loanSteps.application.negative.title')}
        </Typography>
        <LoanProcessStatusIconWrapper iconType="error">
          <CloseIcon />
        </LoanProcessStatusIconWrapper>
        {loanRejectionDescription && loanRejectionDescription.length > 0 ? (
          <Box sx={{ marginY: 2 }} flexDirection="column" display="flex" gap={2}>
            {loanRejectionDescription.slice(0, 3).map((reason) => (
              <Typography
                textAlign="center"
                component="p"
                dangerouslySetInnerHTML={{ __html: reason }}
              />
            ))}
          </Box>
        ) : null}
      </Stack>
      <Button
        color="secondary"
        data-testid="application-negative-button"
        fullWidth
        onClick={closeModalAndGoToDashboard}
        sx={{ paddingY: { md: '14px', xs: '8px' } }}
        variant="contained"
      >
        {t('loanProcess.loanSteps.application.negative.button')}
      </Button>
    </Box>
  );
}
